module.exports = __webpack_public_path__ + "img/brackets-check.13f61d8d.svg";